module.exports = __webpack_public_path__ + "static/media/googleIcon.357d7809.svg";